import React from 'react';
import { VersionInfo } from './version-info';

export const VersionInfoContext = React.createContext<VersionInfo>({
  appname: 'sqior Assistant',
  appnameInternal: '',
  version: '',
  mobileClient: false,
});
